module.exports = __webpack_public_path__ + "static/media/qrcode@2x.4d3fd382.png";